import  { Component, useContext } from 'react';

import './Registration-content.component.scss';
import RegistationOptions from './registration-options/registration-options.component'
import LoginContext from '../../../store/login-context';

declare function Translate(key: string): string;

export let translateText = [
    {
      label: 'N_General_SignUp_lobby_title',
      value: 'general header',
    },
    {
      label: 'N_General_SignUp_lobby_info_1',
      value: 'sub header'
    },
    {
      label: 'N_General_SignUp_lobby_info_2',
      value: 'paragraph',
    },
    {
        label: 'N_General_SignUp_lobby_info_3',
        value: 'preLink',
    },
    {
        label: 'N_General_SignUp_lobby_butten_1',
        value: 'link',
    },
  ];

  
  const RegistrationContentComponent = () => {

    const ctx = useContext(LoginContext);

    const handleRegClick = () => {
      ctx.displayRegForm(false);
    };

    return (        
      <>
        <div className='flexContainerInContent verticleCenter'>
            <div className='RegistrationHeader'>
                <div className='h1'>{Translate(translateText[0].label)}</div>
                <h2>{Translate(translateText[1].label)}</h2>
                <p>{Translate(translateText[2].label)}</p>
                <div className='flexContainer'>
                    <div className='preLink'>{Translate(translateText[3].label)}</div>
                    <a className='registrationLink' onClick={handleRegClick}>{Translate(translateText[4].label)}</a>                      
                </div>
            </div>
            
            <RegistationOptions/>

        </div>          
      </>
    );
  };
  export default RegistrationContentComponent;
